// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonStyles-module__font-s-10___j3SSC {
  font-size: 10px !important;
}

.commonStyles-module__font-s-12___SHmkp {
  font-size: 12px !important;
}

.commonStyles-module__font-s-13___BXncN {
  font-size: 13px !important;
}

.commonStyles-module__font-s-14____P8Ke {
  font-size: 14px !important;
}

.commonStyles-module__font-s-15___Zd_6X {
  font-size: 15px !important;
}

.commonStyles-module__font-s-16___Gmb7j {
  font-size: 16px !important;
}

.commonStyles-module__font-s-18___RhodL {
  font-size: 18px !important;
}

.commonStyles-module__font-s-20___jdAUu {
  font-size: 20px !important;
}

.commonStyles-module__font-s-22___c_qGe {
  font-size: 22px !important;
}

.commonStyles-module__font-s-28___bxrgE {
  font-size: 28px !important;
}

.commonStyles-module__font-w-400___waCX2 {
  font-weight: 400 !important;
}

.commonStyles-module__font-w-500___yoB6f {
  font-weight: 500 !important;
}

.commonStyles-module__font-w-600___reBCN {
  font-weight: 600 !important;
}

.commonStyles-module__font-w-700___ctslf {
  font-weight: 700 !important;
}

.commonStyles-module__p-5___tKOEm {
  padding: 5px !important;
}

.commonStyles-module__p-12___abq4f {
  padding: 12px !important;
}

.commonStyles-module__p-16___5hXqM {
  padding: 16px !important;
}

.commonStyles-module__p-30___HrmEc {
  padding: 30px !important;
}

.commonStyles-module__p-b-0___bRtqf {
  padding-bottom: 0 !important;
}

.commonStyles-module__p-b-5___ZHCqt {
  padding-bottom: 5px !important;
}

.commonStyles-module__p-b-10___K2yb2 {
  padding-bottom: 10px !important;
}

.commonStyles-module__p-b-12___OvbT1 {
  padding-bottom: 12px !important;
}

.commonStyles-module__p-b-16___OaCGT {
  padding-bottom: 16px !important;
}

.commonStyles-module__p-b-18___Zrful {
  padding-bottom: 18px !important;
}

.commonStyles-module__p-b-20___rxp_1 {
  padding-bottom: 20px !important;
}

.commonStyles-module__p-b-25___l4Mu8 {
  padding-bottom: 25px !important;
}

.commonStyles-module__p-b-30___M3CNv {
  padding-bottom: 30px !important;
}

.commonStyles-module__p-b-50___IUYyK {
  padding-bottom: 50px !important;
}

.commonStyles-module__p-t-0___hJ5CS {
  padding-top: 0 !important;
}

.commonStyles-module__p-t-12___keoFo {
  padding-top: 12px !important;
}

.commonStyles-module__p-t-16___t9yaf {
  padding-top: 16px !important;
}

.commonStyles-module__p-t-18___nVfF6 {
  padding-top: 18px !important;
}

.commonStyles-module__p-t-20___SDyQG {
  padding-top: 20px !important;
}

.commonStyles-module__p-t-30___eEzMf {
  padding-top: 30px !important;
}

.commonStyles-module__p-t-40___frgTk {
  padding-top: 40px !important;
}

.commonStyles-module__p-t-50___selUk {
  padding-top: 50px !important;
}

.commonStyles-module__p-l-20___Lpo0f {
  padding-left: 20px !important;
}

.commonStyles-module__p-l-30___mTFRm {
  padding-left: 30px !important;
}

.commonStyles-module__p-l-40___Ad3s8 {
  padding-left: 40px !important;
}

.commonStyles-module__p-r-16___F5Kmp {
  padding-right: 16px !important;
}

.commonStyles-module__p-r-20___Cze2d {
  padding-right: 20px !important;
}

.commonStyles-module__p-r-30___sUq2J {
  padding-right: 30px !important;
}

.commonStyles-module__p-r-50___m5vR0 {
  padding-right: 50px !important;
}

.commonStyles-module__p-r-60____ahqA {
  padding-right: 60px !important;
}

.commonStyles-module__m-b-1___P5EWs {
  margin-bottom: 1px !important;
}

.commonStyles-module__m-b-2___lcxLM {
  margin-bottom: 2px !important;
}

.commonStyles-module__m-b-6___espru {
  margin-bottom: 6px !important;
}

.commonStyles-module__m-b-8___h8UQJ {
  margin-bottom: 8px !important;
}

.commonStyles-module__m-b-10___paeV4 {
  margin-bottom: 10px !important;
}

.commonStyles-module__m-b-14___BXL3j {
  margin-bottom: 14px !important;
}

.commonStyles-module__m-b-16___x1o4z {
  margin-bottom: 16px !important;
}

.commonStyles-module__m-b-20____lXCz {
  margin-bottom: 20px !important;
}

.commonStyles-module__m-b-22___KIP8J {
  margin-bottom: 22px !important;
}

.commonStyles-module__m-b-24___QOytE {
  margin-bottom: 24px !important;
}

.commonStyles-module__m-b-30___LEeI_ {
  margin-bottom: 30px !important;
}

.commonStyles-module__m-b-32___jvSf4 {
  margin-bottom: 32px !important;
}

.commonStyles-module__m-b-40___oUVGq {
  margin-bottom: 40px !important;
}

.commonStyles-module__m-t-2___A_hvb {
  margin-top: 2px !important;
}

.commonStyles-module__m-t-3___ieeia {
  margin-top: 3px !important;
}

.commonStyles-module__m-t-4___lWKXg {
  margin-top: 4px !important;
}

.commonStyles-module__m-t-5___vGvad {
  margin-top: 5px !important;
}

.commonStyles-module__m-t-8___Y6YYp {
  margin-top: 8px !important;
}

.commonStyles-module__m-t-10___NYsJz {
  margin-top: 10px !important;
}

.commonStyles-module__m-t-15___BEc00 {
  margin-top: 15px !important;
}

.commonStyles-module__m-t-16___tXeB3 {
  margin-top: 16px !important;
}

.commonStyles-module__m-t-20___ZLOdF {
  margin-top: 20px !important;
}

.commonStyles-module__m-t-22___EFjQ9 {
  margin-top: 22px !important;
}

.commonStyles-module__m-t-30___qnQnr {
  margin-top: 30px !important;
}

.commonStyles-module__m-t-32___QfUZ7 {
  margin-top: 32px !important;
}

.commonStyles-module__m-l-auto___KblH9 {
  margin-left: auto !important;
}

.commonStyles-module__m-l-4___j__NN {
  margin-left: 4px !important;
}

.commonStyles-module__m-l-5___ye_4S {
  margin-left: 5px !important;
}

.commonStyles-module__m-l-6___QL87z {
  margin-left: 6px !important;
}

.commonStyles-module__m-l-8___vG2iw {
  margin-left: 8px !important;
}

.commonStyles-module__m-l-10___IS3vD {
  margin-left: 10px !important;
}

.commonStyles-module__m-l-16___C2yDb {
  margin-left: 16px !important;
}

.commonStyles-module__m-l-20___mmiTY {
  margin-left: 20px !important;
}

.commonStyles-module__m-l-24___IcTU8 {
  margin-left: 24px !important;
}

.commonStyles-module__m-l-30___mjWCM {
  margin-left: 30px !important;
}

.commonStyles-module__m-l-35___dWqXN {
  margin-left: 35px !important;
}

.commonStyles-module__m-l-40___AQim2 {
  margin-left: 40px !important;
}

.commonStyles-module__m-r-8___AboFx {
  margin-right: 8px !important;
}

.commonStyles-module__m-r-10___YMh56 {
  margin-right: 10px !important;
}

.commonStyles-module__m-r-16___yaGYz {
  margin-right: 16px !important;
}

.commonStyles-module__m-r-20___AVZ1y {
  margin-right: 20px !important;
}

.commonStyles-module__m-r-24____41jl {
  margin-right: 24px !important;
}

.commonStyles-module__m-r-30___tCcKx {
  margin-right: 30px !important;
}

.commonStyles-module__m-r-40___Hiw15 {
  margin-right: 40px !important;
}

.commonStyles-module__border-r-3____Wxb4 {
  border-radius: 3px !important;
}

.commonStyles-module__border-r-4___ZWKy9 {
  border-radius: 4px !important;
}

.commonStyles-module__border-r-6___QI3Kz {
  border-radius: 6px !important;
}

.commonStyles-module__border-r-10___uSlhs {
  border-radius: 10px !important;
}

.commonStyles-module__border-r-12___qUfIz {
  border-radius: 12px !important;
}

.commonStyles-module__border-r-16___ls5Ro {
  border-radius: 16px !important;
}

.commonStyles-module__border-r-50___ntpCr {
  border-radius: 50% !important;
}

.commonStyles-module__primary-border___oabjA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-b___MoPYq {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-t____8NJl {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-l___PeqBv {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__primary-border-r___RxSyO {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.commonStyles-module__secondary-border___dvp0U {
  border: 1px solid #637768;
}

.commonStyles-module__secondary-border-b___PodBr {
  border-bottom: 1px solid #637768;
}

.commonStyles-module__secondary-border-t___r276I {
  border-top: 1px solid #637768;
}

.commonStyles-module__secondary-border-l___ub8J6 {
  border-left: 1px solid #637768;
}

.commonStyles-module__secondary-border-r___vASDk {
  border-right: 1px solid #637768;
}

.commonStyles-module__gap-0___ShLZT {
  gap: 0 !important;
}

.commonStyles-module__gap-2___KbByE {
  gap: 2px !important;
}

.commonStyles-module__gap-4___kW9oU {
  gap: 4px !important;
}

.commonStyles-module__gap-5___WFVJI {
  gap: 5px !important;
}

.commonStyles-module__gap-6___vF1gU {
  gap: 6px !important;
}

.commonStyles-module__gap-8___OObCp {
  gap: 8px !important;
}

.commonStyles-module__gap-10___kxf41 {
  gap: 10px !important;
}

.commonStyles-module__gap-12___R4E0R {
  gap: 12px !important;
}

.commonStyles-module__gap-14___ihkiJ {
  gap: 14px !important;
}

.commonStyles-module__gap-16___DO7eR {
  gap: 16px !important;
}

.commonStyles-module__gap-18___Ph0qN {
  gap: 18px !important;
}

.commonStyles-module__gap-20___Wd2I8 {
  gap: 20px !important;
}

.commonStyles-module__gap-24___TTuxF {
  gap: 24px !important;
}

.commonStyles-module__gap-26___EETyP {
  gap: 26px !important;
}

.commonStyles-module__gap-30___Ln62I {
  gap: 30px !important;
}

.commonStyles-module__gap-32___TtmXS {
  gap: 32px !important;
}

.commonStyles-module__gap-40___OeIN2 {
  gap: 40px !important;
}

.commonStyles-module__gap-50___KQjTX {
  gap: 50px !important;
}

.commonStyles-module__flex-1___hFDeF {
  flex: 1;
}

.commonStyles-module__flex-none___Z5S0p {
  flex: none !important;
}

.commonStyles-module__flex-column___IwUDo {
  display: flex;
  flex-direction: column !important;
}

.commonStyles-module__flex-row___fReSE {
  display: flex;
  flex-direction: row !important;
}

.commonStyles-module__vertically-centered___gvXVr {
  display: flex;
  align-items: center !important;
}

.commonStyles-module__horizontally-centered___hz5kL {
  display: flex;
  justify-content: center !important;
}

.commonStyles-module__horizontally-end___hm2QF {
  display: flex;
  justify-content: end !important;
}

.commonStyles-module__vertically-start___wIDUK {
  display: flex;
  align-items: start !important;
}

.commonStyles-module__space-between___jR2pB {
  display: flex;
  justify-content: space-between !important;
}

.commonStyles-module__flex-wrap___cExfe {
  flex-wrap: wrap !important;
}

.commonStyles-module__height-100___yhAZv {
  height: 100%;
}

.commonStyles-module__width-50___MBhbQ {
  width: 50% !important;
}

.commonStyles-module__width-100___F5zjU {
  width: 100%;
}

.commonStyles-module__cursor-pointer___zKA_S {
  cursor: pointer;
}

.commonStyles-module__cursor-not-allowed___GoLjs {
  cursor: not-allowed !important;
}

.commonStyles-module__absolute-centered___pn0Lk {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.commonStyles-module__absolute___IsWW7 {
  position: absolute;
}

.commonStyles-module__relative___HQ_rJ {
  position: relative;
}

.commonStyles-module__fixed___GCKya {
  position: fixed;
}

.commonStyles-module__visible___Co1nB {
  opacity: 1;
}

.commonStyles-module__invisible___cHran {
  opacity: 0;
}

.commonStyles-module__col-90___Qm6WX {
  width: 90% !important;
}

.commonStyles-module__col-auto___VGWHP {
  width: auto !important;
}

.commonStyles-module__medical-tabs___Dzzl7 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.commonStyles-module__medical-table-new___wBKDE {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___wBKDE:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___wBKDE::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___wBKDE::-webkit-scrollbar-track {
  display: none;
}
.commonStyles-module__medical-table-new___wBKDE.commonStyles-module__no-pagination___aB9_v {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.commonStyles-module__medical-table-new___wBKDE.commonStyles-module__no-pagination___aB9_v:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.commonStyles-module__medical-table-new___wBKDE.commonStyles-module__no-pagination___aB9_v::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.commonStyles-module__medical-table-new___wBKDE.commonStyles-module__no-pagination___aB9_v::-webkit-scrollbar-track {
  display: none;
}

.commonStyles-module__medical-table-empty___X7Tdb {
  padding: 14px 40px !important;
}

.commonStyles-module__icon-btn___F25oo {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.commonStyles-module__search-icon___Xjxnp {
  width: 24px;
  height: 24px;
  align-self: center;
}

.commonStyles-module__disable-select___RtjnH {
  user-select: none;
}

.commonStyles-module__break-word___KJMTi {
  word-break: break-word;
}

.commonStyles-module__popup-clear-btn___PehVQ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.commonStyles-module__scroll-m-b-20___zPKEl {
  scroll-margin-bottom: 20px;
}

.commonStyles-module__date___pE_Pw {
  height: 40px !important;
}
.commonStyles-module__date___pE_Pw .commonStyles-module__inputDateContainer___k38Kk {
  padding: 8px 16px;
}
.commonStyles-module__date___pE_Pw .commonStyles-module__inputDateContainer___k38Kk .commonStyles-module__dateInput___fMuoS {
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 16px !important;
}

.commonStyles-module__input___pgh9p {
  min-width: 250px;
  width: 66%;
}

.commonStyles-module__inputText___TDeGs {
  font-size: 14px !important;
  font-weight: 400 !important;
  padding: 10px 14px !important;
  line-height: 16px !important;
}

.commonStyles-module__inputNumber___QEQBK input {
  font-size: 14px !important;
  font-weight: 400 !important;
  padding: 9px 14px !important;
  line-height: 16px !important;
}
.commonStyles-module__inputNumber___QEQBK input:disabled {
  opacity: 0.8;
}

.commonStyles-module__checkbox___aCwWS input:checked ~ span {
  border: 1px solid #375844 !important;
}
.commonStyles-module__checkbox___aCwWS input:checked ~ span small {
  border-right: 2.5px solid #375844 !important;
  border-bottom: 2.5px solid #375844 !important;
  height: 9px !important;
  width: 3.5px !important;
  right: 4px !important;
  bottom: 2px !important;
}
.commonStyles-module__checkbox___aCwWS span {
  border: 1px solid #d3d3d3 !important;
  background-color: transparent !important;
  border-radius: 2px !important;
  min-height: 16px !important;
  min-width: 16px !important;
}
.commonStyles-module__checkbox___aCwWS div {
  font-weight: 400 !important;
}

.commonStyles-module__radio___F29Yx {
  font-weight: 400 !important;
}
.commonStyles-module__radio___F29Yx.commonStyles-module__row___r8gMM {
  margin-bottom: 0 !important;
}
.commonStyles-module__radio___F29Yx + span + button, .commonStyles-module__radio___F29Yx + button {
  margin-left: 0 !important;
  padding: 0 !important;
  min-width: auto !important;
  font-size: 12px !important;
  color: #bcbec0 !important;
}
.commonStyles-module__radio___F29Yx > div {
  border: 1px solid #d3d3d3;
  min-width: 16px !important;
  min-height: 16px !important;
}
.commonStyles-module__radio___F29Yx > div span {
  width: 8px !important;
  height: 8px !important;
}

.commonStyles-module__multiSelect___EmU21 {
  min-width: 250px;
  width: 33% !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/commonStyles.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,uBAAA;AA8pBF;AA5pBE;EACE,iBAAA;AA8pBJ;AA5pBI;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;AA8pBN;;AAzpBA;EACE,gBAAA;EACA,UAAA;AA4pBF;;AAzpBA;EACE,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,4BAAA;AA4pBF;;AAxpBE;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,4BAAA;AA2pBJ;AAzpBI;EACE,YAAA;AA2pBN;;AArpBE;EACE,oCAAA;AAwpBJ;AAtpBI;EACE,4CAAA;EACA,6CAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;AAwpBN;AAppBE;EACE,oCAAA;EACA,wCAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;AAspBJ;AAnpBE;EACE,2BAAA;AAqpBJ;;AAjpBA;EACE,2BAAA;AAopBF;AAlpBE;EACE,2BAAA;AAopBJ;AAjpBE;EAEE,yBAAA;EACA,qBAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;AAkpBJ;AA/oBE;EACE,yBAAA;EACA,0BAAA;EACA,2BAAA;AAipBJ;AA/oBI;EACE,qBAAA;EACA,sBAAA;AAipBN;;AA5oBA;EACE,gBAAA;EACA,qBAAA;AA+oBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.date {\n  height: 40px !important;\n\n  .inputDateContainer {\n    padding: 8px 16px;\n\n    .dateInput {\n      font-size: 14px !important;\n      font-weight: 400 !important;\n      line-height: 16px !important;\n    }\n  }\n}\n\n.input {\n  min-width: 250px;\n  width: 66%;\n}\n\n.inputText {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  padding: 10px 14px !important;\n  line-height: 16px !important;\n}\n\n.inputNumber {\n  input {\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    padding: 9px 14px !important;\n    line-height: 16px !important;\n\n    &:disabled {\n      opacity: 0.8;\n    }\n  }\n}\n\n.checkbox {\n  input:checked ~ span {\n    border: 1px solid get-color(greenNew, dark) !important;\n\n    small {\n      border-right: 2.5px solid #375844 !important;\n      border-bottom: 2.5px solid #375844 !important;\n      height: 9px !important;\n      width: 3.5px !important;\n      right: 4px !important;\n      bottom: 2px !important;\n    }\n  }\n\n  span {\n    border: 1px solid get-color(gray) !important;\n    background-color: transparent !important;\n    border-radius: 2px !important;\n    min-height: 16px !important;\n    min-width: 16px !important;\n  }\n\n  div {\n    font-weight: 400 !important;\n  }\n}\n\n.radio {\n  font-weight: 400 !important;\n\n  &.row {\n    margin-bottom: 0 !important;\n  }\n\n  & + span + button,\n  & + button {\n    margin-left: 0 !important;\n    padding: 0 !important;\n    min-width: auto !important;\n    font-size: 12px !important;\n    color: get-color(gray, medium) !important;\n  }\n\n  & > div {\n    border: 1px solid get-color(gray);\n    min-width: 16px !important;\n    min-height: 16px !important;\n\n    span {\n      width: 8px !important;\n      height: 8px !important;\n    }\n  }\n}\n\n.multiSelect {\n  min-width: 250px;\n  width: 33% !important;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `commonStyles-module__font-s-10___j3SSC`,
	"fontS12": `commonStyles-module__font-s-12___SHmkp`,
	"fontS13": `commonStyles-module__font-s-13___BXncN`,
	"fontS14": `commonStyles-module__font-s-14____P8Ke`,
	"fontS15": `commonStyles-module__font-s-15___Zd_6X`,
	"fontS16": `commonStyles-module__font-s-16___Gmb7j`,
	"fontS18": `commonStyles-module__font-s-18___RhodL`,
	"fontS20": `commonStyles-module__font-s-20___jdAUu`,
	"fontS22": `commonStyles-module__font-s-22___c_qGe`,
	"fontS28": `commonStyles-module__font-s-28___bxrgE`,
	"fontW400": `commonStyles-module__font-w-400___waCX2`,
	"fontW500": `commonStyles-module__font-w-500___yoB6f`,
	"fontW600": `commonStyles-module__font-w-600___reBCN`,
	"fontW700": `commonStyles-module__font-w-700___ctslf`,
	"p5": `commonStyles-module__p-5___tKOEm`,
	"p12": `commonStyles-module__p-12___abq4f`,
	"p16": `commonStyles-module__p-16___5hXqM`,
	"p30": `commonStyles-module__p-30___HrmEc`,
	"pB0": `commonStyles-module__p-b-0___bRtqf`,
	"pB5": `commonStyles-module__p-b-5___ZHCqt`,
	"pB10": `commonStyles-module__p-b-10___K2yb2`,
	"pB12": `commonStyles-module__p-b-12___OvbT1`,
	"pB16": `commonStyles-module__p-b-16___OaCGT`,
	"pB18": `commonStyles-module__p-b-18___Zrful`,
	"pB20": `commonStyles-module__p-b-20___rxp_1`,
	"pB25": `commonStyles-module__p-b-25___l4Mu8`,
	"pB30": `commonStyles-module__p-b-30___M3CNv`,
	"pB50": `commonStyles-module__p-b-50___IUYyK`,
	"pT0": `commonStyles-module__p-t-0___hJ5CS`,
	"pT12": `commonStyles-module__p-t-12___keoFo`,
	"pT16": `commonStyles-module__p-t-16___t9yaf`,
	"pT18": `commonStyles-module__p-t-18___nVfF6`,
	"pT20": `commonStyles-module__p-t-20___SDyQG`,
	"pT30": `commonStyles-module__p-t-30___eEzMf`,
	"pT40": `commonStyles-module__p-t-40___frgTk`,
	"pT50": `commonStyles-module__p-t-50___selUk`,
	"pL20": `commonStyles-module__p-l-20___Lpo0f`,
	"pL30": `commonStyles-module__p-l-30___mTFRm`,
	"pL40": `commonStyles-module__p-l-40___Ad3s8`,
	"pR16": `commonStyles-module__p-r-16___F5Kmp`,
	"pR20": `commonStyles-module__p-r-20___Cze2d`,
	"pR30": `commonStyles-module__p-r-30___sUq2J`,
	"pR50": `commonStyles-module__p-r-50___m5vR0`,
	"pR60": `commonStyles-module__p-r-60____ahqA`,
	"mB1": `commonStyles-module__m-b-1___P5EWs`,
	"mB2": `commonStyles-module__m-b-2___lcxLM`,
	"mB6": `commonStyles-module__m-b-6___espru`,
	"mB8": `commonStyles-module__m-b-8___h8UQJ`,
	"mB10": `commonStyles-module__m-b-10___paeV4`,
	"mB14": `commonStyles-module__m-b-14___BXL3j`,
	"mB16": `commonStyles-module__m-b-16___x1o4z`,
	"mB20": `commonStyles-module__m-b-20____lXCz`,
	"mB22": `commonStyles-module__m-b-22___KIP8J`,
	"mB24": `commonStyles-module__m-b-24___QOytE`,
	"mB30": `commonStyles-module__m-b-30___LEeI_`,
	"mB32": `commonStyles-module__m-b-32___jvSf4`,
	"mB40": `commonStyles-module__m-b-40___oUVGq`,
	"mT2": `commonStyles-module__m-t-2___A_hvb`,
	"mT3": `commonStyles-module__m-t-3___ieeia`,
	"mT4": `commonStyles-module__m-t-4___lWKXg`,
	"mT5": `commonStyles-module__m-t-5___vGvad`,
	"mT8": `commonStyles-module__m-t-8___Y6YYp`,
	"mT10": `commonStyles-module__m-t-10___NYsJz`,
	"mT15": `commonStyles-module__m-t-15___BEc00`,
	"mT16": `commonStyles-module__m-t-16___tXeB3`,
	"mT20": `commonStyles-module__m-t-20___ZLOdF`,
	"mT22": `commonStyles-module__m-t-22___EFjQ9`,
	"mT30": `commonStyles-module__m-t-30___qnQnr`,
	"mT32": `commonStyles-module__m-t-32___QfUZ7`,
	"mLAuto": `commonStyles-module__m-l-auto___KblH9`,
	"mL4": `commonStyles-module__m-l-4___j__NN`,
	"mL5": `commonStyles-module__m-l-5___ye_4S`,
	"mL6": `commonStyles-module__m-l-6___QL87z`,
	"mL8": `commonStyles-module__m-l-8___vG2iw`,
	"mL10": `commonStyles-module__m-l-10___IS3vD`,
	"mL16": `commonStyles-module__m-l-16___C2yDb`,
	"mL20": `commonStyles-module__m-l-20___mmiTY`,
	"mL24": `commonStyles-module__m-l-24___IcTU8`,
	"mL30": `commonStyles-module__m-l-30___mjWCM`,
	"mL35": `commonStyles-module__m-l-35___dWqXN`,
	"mL40": `commonStyles-module__m-l-40___AQim2`,
	"mR8": `commonStyles-module__m-r-8___AboFx`,
	"mR10": `commonStyles-module__m-r-10___YMh56`,
	"mR16": `commonStyles-module__m-r-16___yaGYz`,
	"mR20": `commonStyles-module__m-r-20___AVZ1y`,
	"mR24": `commonStyles-module__m-r-24____41jl`,
	"mR30": `commonStyles-module__m-r-30___tCcKx`,
	"mR40": `commonStyles-module__m-r-40___Hiw15`,
	"borderR3": `commonStyles-module__border-r-3____Wxb4`,
	"borderR4": `commonStyles-module__border-r-4___ZWKy9`,
	"borderR6": `commonStyles-module__border-r-6___QI3Kz`,
	"borderR10": `commonStyles-module__border-r-10___uSlhs`,
	"borderR12": `commonStyles-module__border-r-12___qUfIz`,
	"borderR16": `commonStyles-module__border-r-16___ls5Ro`,
	"borderR50": `commonStyles-module__border-r-50___ntpCr`,
	"primaryBorder": `commonStyles-module__primary-border___oabjA`,
	"primaryBorderB": `commonStyles-module__primary-border-b___MoPYq`,
	"primaryBorderT": `commonStyles-module__primary-border-t____8NJl`,
	"primaryBorderL": `commonStyles-module__primary-border-l___PeqBv`,
	"primaryBorderR": `commonStyles-module__primary-border-r___RxSyO`,
	"secondaryBorder": `commonStyles-module__secondary-border___dvp0U`,
	"secondaryBorderB": `commonStyles-module__secondary-border-b___PodBr`,
	"secondaryBorderT": `commonStyles-module__secondary-border-t___r276I`,
	"secondaryBorderL": `commonStyles-module__secondary-border-l___ub8J6`,
	"secondaryBorderR": `commonStyles-module__secondary-border-r___vASDk`,
	"gap0": `commonStyles-module__gap-0___ShLZT`,
	"gap2": `commonStyles-module__gap-2___KbByE`,
	"gap4": `commonStyles-module__gap-4___kW9oU`,
	"gap5": `commonStyles-module__gap-5___WFVJI`,
	"gap6": `commonStyles-module__gap-6___vF1gU`,
	"gap8": `commonStyles-module__gap-8___OObCp`,
	"gap10": `commonStyles-module__gap-10___kxf41`,
	"gap12": `commonStyles-module__gap-12___R4E0R`,
	"gap14": `commonStyles-module__gap-14___ihkiJ`,
	"gap16": `commonStyles-module__gap-16___DO7eR`,
	"gap18": `commonStyles-module__gap-18___Ph0qN`,
	"gap20": `commonStyles-module__gap-20___Wd2I8`,
	"gap24": `commonStyles-module__gap-24___TTuxF`,
	"gap26": `commonStyles-module__gap-26___EETyP`,
	"gap30": `commonStyles-module__gap-30___Ln62I`,
	"gap32": `commonStyles-module__gap-32___TtmXS`,
	"gap40": `commonStyles-module__gap-40___OeIN2`,
	"gap50": `commonStyles-module__gap-50___KQjTX`,
	"flex1": `commonStyles-module__flex-1___hFDeF`,
	"flexNone": `commonStyles-module__flex-none___Z5S0p`,
	"flexColumn": `commonStyles-module__flex-column___IwUDo`,
	"flexRow": `commonStyles-module__flex-row___fReSE`,
	"verticallyCentered": `commonStyles-module__vertically-centered___gvXVr`,
	"horizontallyCentered": `commonStyles-module__horizontally-centered___hz5kL`,
	"horizontallyEnd": `commonStyles-module__horizontally-end___hm2QF`,
	"verticallyStart": `commonStyles-module__vertically-start___wIDUK`,
	"spaceBetween": `commonStyles-module__space-between___jR2pB`,
	"flexWrap": `commonStyles-module__flex-wrap___cExfe`,
	"height100": `commonStyles-module__height-100___yhAZv`,
	"width50": `commonStyles-module__width-50___MBhbQ`,
	"width100": `commonStyles-module__width-100___F5zjU`,
	"cursorPointer": `commonStyles-module__cursor-pointer___zKA_S`,
	"cursorNotAllowed": `commonStyles-module__cursor-not-allowed___GoLjs`,
	"absoluteCentered": `commonStyles-module__absolute-centered___pn0Lk`,
	"absolute": `commonStyles-module__absolute___IsWW7`,
	"relative": `commonStyles-module__relative___HQ_rJ`,
	"fixed": `commonStyles-module__fixed___GCKya`,
	"visible": `commonStyles-module__visible___Co1nB`,
	"invisible": `commonStyles-module__invisible___cHran`,
	"col90": `commonStyles-module__col-90___Qm6WX`,
	"colAuto": `commonStyles-module__col-auto___VGWHP`,
	"medicalTabs": `commonStyles-module__medical-tabs___Dzzl7`,
	"medicalTableNew": `commonStyles-module__medical-table-new___wBKDE`,
	"noPagination": `commonStyles-module__no-pagination___aB9_v`,
	"medicalTableEmpty": `commonStyles-module__medical-table-empty___X7Tdb`,
	"iconBtn": `commonStyles-module__icon-btn___F25oo`,
	"searchIcon": `commonStyles-module__search-icon___Xjxnp`,
	"disableSelect": `commonStyles-module__disable-select___RtjnH`,
	"breakWord": `commonStyles-module__break-word___KJMTi`,
	"popupClearBtn": `commonStyles-module__popup-clear-btn___PehVQ`,
	"scrollMB20": `commonStyles-module__scroll-m-b-20___zPKEl`,
	"date": `commonStyles-module__date___pE_Pw`,
	"inputDateContainer": `commonStyles-module__inputDateContainer___k38Kk`,
	"dateInput": `commonStyles-module__dateInput___fMuoS`,
	"input": `commonStyles-module__input___pgh9p`,
	"inputText": `commonStyles-module__inputText___TDeGs`,
	"inputNumber": `commonStyles-module__inputNumber___QEQBK`,
	"checkbox": `commonStyles-module__checkbox___aCwWS`,
	"radio": `commonStyles-module__radio___F29Yx`,
	"row": `commonStyles-module__row___r8gMM`,
	"multiSelect": `commonStyles-module__multiSelect___EmU21`
};
module.exports = ___CSS_LOADER_EXPORT___;
